<template>
    <button class="retail-button">
        <slot />
    </button>
</template>

<style scoped>
.retail-button {
    background-color: #ffffff;
    border: 2px solid #000000;
    border-radius: 12px 12px 12px 12px;
    box-sizing: border-box;
    color: #000000;
    cursor: pointer;
    float: left;
    font-size: 14px;
    font-weight: 500;
    height: 32px;
    line-height: 28px;
    outline: none;
    padding: 0px 0px 0px 0px;
    text-transform: uppercase;
    transition: background-color 0.25s ease-in-out, color 0.25s ease-in-out;
    width: 176px;
}

.retail-button:active {
    background-color: #000000;
    color: #ffffff;
}
</style>

<script>
export const RetailButton = {
    name: "retail-button"
};

export default RetailButton;
</script>
